"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ComplianceSupport() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pressMentions = [{
    publication: "Industry Standards",
    citation: "ISO 9001 Certified"
  }, {
    publication: "Global Compliance",
    citation: "Regulatory Excellence 2024"
  }, {
    publication: "Safety Council",
    citation: "Gold Standard Member"
  }, {
    publication: "Audit Review",
    citation: "Verified Compliant"
  }, {
    publication: "Legal Watch",
    citation: "Top Tier Governance"
  }, {
    publication: "Risk Management",
    citation: "Accredited Partner"
  }];
  return;
}